<template>
  <div class="app-login">
    <input type="hidden" id="captchaKey" :value="captchaKey" />
    <input type="hidden" id="captchaUrl" :value="captchaUrl" />
    <form class="app-login-form" :callback="entrar" @submit.prevent="controlCaptcha">
      <img class="app-login-logo" src="../assets/img/logo_white.png" alt="Eurocaja Rural"/>
      <h4 class="app-login-title">Portal de Proveedores de Confirming</h4>
      <div class="form-group">
        <div class="mensajeConfirmacionReducido" v-if="$route.params.confirmacion=='OK'">
          <p>check_circle</p>
          <h3>Cambio de contraseña realizado. Por favor, inicie sesión con su nueva contraseña.</h3>
       </div>
        <div class="mensajeErrorReducido" v-if="$route.params.confirmacion=='KO'">
          <p>check_circle</p>
          <h3>{{$route.params.mensaje}}</h3>
       </div>
        <div class="mensajeErrorReducido" v-if="confirmacion=='KO'">
          <p>warning</p>
          <h3 v-if="!mensajePrimerLogin">{{mensajeError}}</h3>
          <!--<h3 v-if="mensajePrimerLogin">Se te ha enviado una contraseña temporal a tu dispositivo móvil. Haz <router-link to="/primera-identificacion"  class="link" color="red"><u>click</u></router-link> aquí.</h3>-->
          <h3 v-if="mensajePrimerLogin">Se te ha enviado una contraseña temporal a tu dispositivo móvil. Haz <a href="https://onesaitportal.eurocajarural.es/onesaitEBanking/index.html">click</a> aquí.</h3>
        </div>
					<input type="hidden" id="g-recaptcha-response" name="g-recaptcha-response" :value="grecaptchaResponse">
          <!-- <input class="inputLoginComponent" type="text" name="userName" placeholder="Usuario" autocomplete="off" v-model="credentials.userName" required/> -->
          <input class="inputLoginComponent" type="text" name="documentId" placeholder="NIF/NIE" autocomplete="off" v-model="credentials.documentId" required :disabled="datosOTP"/>
           <!--<input class="inputLoginComponent" maxlength="6" @keypress="numericInput" required :type="textPass1" name="password" placeholder="Contraseña" autocomplete="off" v-model="credentials.password" :disabled="datosOTP"/>-->
           <input class="inputLoginComponent" maxlength="6" required :type="textPass1" name="password" placeholder="Contraseña" autocomplete="off" v-model="credentials.password" :disabled="datosOTP"/>
          <span class="material-icons visibility" id="eye2" @click="showPassword" v-if="eye1 && !datosOTP">visibility</span>
          <span class="material-icons visibility" id="eye2" @click="hidePassword" v-if="!eye1 && !datosOTP">visibility_off</span>
          <router-link v-if=!datosFirma class="app-login-forgot" to="/olvido-contrasena">¿Has olvidado tu contraseña?</router-link>
          <br/>
          <div v-if=datosOTP>
                <OTPComponent :params="params" :datosOTP="datosOTP" :llamada="llamada" @aceptar="callBackAceptarOTP" @cancelar="callBackCancelarOTP"></OTPComponent>
              </div>
          <div class="firmaconLogin" v-if=datosFirma>
              <SignatureComponent :params="params" :datosFirma="datosFirma" :llamada="llamada" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
          </div>
          <input class="btnPrimary" type="submit" value="Entrar" :disabled="isDisabled" v-if=beforeSubmit>
          <!--ESTO DE MOMENTO COMENTADO YA QUE NO ESTA CLARO SI HARA LA MISMA LLAMADA QUE PRIMER LOGIN DE CLIENTE, EN ESE CASO IRIA EN EL MISMO COMPONENTE Y
              EL OAUTH TOKEN DEBERIA DEVOLVER SI ES CLIENTE O NO, PARA EL FRONT ACTUAR EN CONSECUENCIA (PRIMERA PASSWORD PARA CLIENTES O DESCARGA DE CONTRATO PARA NO CLIENTES)-->
            <span class="app-login-firstLogin">*Si es la primera vez que accedes al servicio, para descargar tu contrato
            <router-link to="/primera-identificacion-no-cliente"  class="link">pulsa aquí</router-link> 
          </span>
          <div class="app-login-disclaimer">
            <div class="icon-lock">
              
            </div>
            <p>
                Recomendaciones de Seguridad:
                <br/>
                <br/>
                Mantén tus claves en secreto y cámbialas regularmente.
                <br/>
                No introduzcas la Clave de Firma para consulta de saldo, movimientos, o sin haber iniciado ninguna operación.
                <br/>
                No olvides pulsar salir al terminar tu sesión.
                <br/>
                Nunca te solicitaremos tus claves personales y confidenciales por teléfono, correo electrónico o fax, ni te pediremos que realices ninguna prueba de operaciones en tu oficina digital.
                <br/>
                <br/>
                Si tienes dudas, llama a nuestro servicio de Atención al cliente 925 26 96 44.
            </p>
          </div>
      </div>
    </form>
  </div>
  <!--hola-->
</template>
<script src="https://www.google.com/recaptcha/api.js" id="captchaInicial" async defer></script> <!--esto es simplemente para que compile, pero en realidad utilizaremos el v3 que metemos luego-->
<script>
import CredentialsLogin from '../models/CredentialsLogin';
import SignatureComponent from './SignatureComponent';
import OTPComponent from './OTPComponent';
export default {
  name: "LoginComponent",
  data() {
    return {
      credentials : new CredentialsLogin(),
        params:null,
        beforeSubmit:true,
      eye1:true,
        datosOTP: null,
      captchaKey:null,
      captchaUrl:null,
      grecaptchaResponse:null,
      textPass1 : "password",
        llamada:null,
        datosFirma: null,
        mensajePrimerLogin:false,
      mensajeError:'Algo ha ido mal, asegúrate que has introducido correctamente tus datos', //mensaje de error por defecto
      confirmacion:null
    }
  },
  computed : {
    isDisabled: function() {
      return  !this.credentials.documentId || !this.credentials.password;
    }
  },
  created: function(){ //llamada a obtener captcha si procede

      
      
      const ventana=this;
      const baseURI = '/auth-server/evaluateCaptcha';
      let loader = this.$loading.show();
      const options = {
        headers: {
            'Authorization':'Basic UENfRXVyb2NhamE6c2VjcmV0X3Bj'
        }
      };
           const params = new URLSearchParams();
      this.$http.get(baseURI,params,options)
      .then((result) => {
        this.resultado=result;
        if(result.data){
          this.captchaKey=result.data.captchaKey;
          this.captchaUrl=result.data.captchaUrl;
          if(this.captchaUrl){
            var s = document.createElement( 'script' );
            s.id='recaptchaV3';
            s.setAttribute( 'src', atob(this.captchaUrl) );
            document.body.appendChild( s );
            //quitamos el otro que era solo para compilar
            /*const captchaInicial = document.getElementById("captchaInicial");
            document.body.removeChild( captchaInicial );*/
          }
        }
      })
      .catch(error => {
        if(error.response){
          var codError = null; 
          var descError = null;
          if(error.response.status != 200) {
            if(error.response.data.result.errors[0].errorCode == "096H") {
              this.datosFirma = error.response.data.result.errors[0].info;
              this.beforeSubmit = false;
            } else {
              codError = error.response.data.result.errors[0].errorCode;
              descError = error.response.data.result.errors[0].errorDescription;
              this.mensajeError = codError + " - " + descError;
              this.confirmacion = "KO";
              loader.hide();
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });
            }
          }
        }else{ //si no, por defecto
          ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
          ventana.confirmacion='KO';
        }
      })     
      .then(function () {
        loader.hide();
      });
    },
    components: {
      SignatureComponent,
      OTPComponent
    },
  methods : {
    callBackAceptar(confirmacion, result){
        this.beforeSubmit = false;
        this.confirmacion = confirmacion;
        this.datosFirma = null;
        if(confirmacion=='KO'){
          this.mensajeError = result;
        }else if(confirmacion=='OK'){
          this.$cookies.set('RT',result.data.refresh_token);
          this.$http.defaults.headers.common['Authorization'] = 'Bearer '+result.data.access_token; //esto establece nuestro access token en el header autorizacion de todas las llamadas, siempre que estemos logeados
          this.$router.push('/consulta-proveedores-apoderado');
        }
      },
     callBackCancelar(){
         this.beforeSubmit = true;
         this.datosFirma = null;
      },
    callBackAceptarOTP(confirmacion, mensaje, codError){
        this.beforeSubmit = false;
        this.confirmacion = confirmacion;
        this.submitted=false;
        if(confirmacion == "OK") {
          this.datosOTP = null;
          this.$cookies.set('RT',mensaje.data.refresh_token);
          this.$http.defaults.headers.common['Authorization'] = 'Bearer '+mensaje.data.access_token; //esto establece nuestro access token en el header autorizacion de todas las llamadas, siempre que estemos logeados
          this.$router.push('/consulta-proveedores-apoderado');
        } else {
          this.mensajeError = mensaje;
          window.scroll({
              top: 470,
              left: 0,
              behavior: 'smooth'
          });
          if(codError == '392H') {
            this.datosOTP = null;
            this.beforeSubmit = true;
          } else if (codError == '089H') {
            this.datosOTP = null;
            this.mensajeError = 'Usuario bloqueado';
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
          }
        }
       /* setTimeout(() => {
          window.location.href = "https://bedemo-eurocaja.ceca.es/3081/3081/#/beext/identificacion";
        }, 5000);*/

       
      },
     callBackCancelarOTP(){
         this.beforeSubmit = true;
         this.submitted=false;
         this.datosOTP = null;
      },
    /*numericInput(a) {
      if (a.which < 48 || a.which > 57) {
        a.preventDefault();
      }
    },*/
    showPassword() {
      this.eye1= false;
      this.textPass1 = "text";
    },
    hidePassword() {
      this.eye1= true;
      this.textPass1 = "password";
    },
    entrar() {
      //borramos y escondemos los avisos que vienen en caso de ser el primer acceso
                    this.$route.params.confirmacion=null;
                    this.$route.params.mensaje=null;
                    const ventana=this;
                    const baseURI = '/auth-server/oauth/token';
                    const options = {
                      headers: {
                          'Authorization':'Basic UENfRXVyb2NhamE6c2VjcmV0X3Bj'
                      }
                    };
                    const params = new URLSearchParams();
                    params.append('username', this.credentials.documentId);
                    params.append('password', this.credentials.password);
                    params.append('grant_type', 'password');
                    params.append('g-recaptcha-response', this.grecaptchaResponse);
                    this.llamada = {
                              urlEndpoint : baseURI,
                              login:true, //indicador de que es una pantalla que aun no tiene access token
                              metodo : 'POST'
                            };
                            
                    this.params = params;
                    let loader = this.$loading.show();
                    this.$http.post(baseURI, params ,options)
                    .then((result) => {
                      this.$cookies.set('RT',result.data.refresh_token);
                      this.$http.defaults.headers.common['Authorization'] = 'Bearer '+result.data.access_token; //esto establece nuestro access token en el header autorizacion de todas las llamadas, siempre que estemos logeados
                      this.$router.push('/consulta-proveedores-apoderado');
                    })
                    .catch(function (error) {
                      if(error.response){ 
                              ventana.mensajePrimerLogin=false;
                              if(error.response.status == 400) {
                                if(error.response.data.result.errors[0].errorCode == "096H") {
                                  if(error.response.data.result.errors[0].info.type=="OTP"){ //pide pin de OTP
                                    ventana.datosOTP = error.response.data.result.errors[0].info;
                                  }else{ //pide clave de firma
                                    ventana.datosFirma = error.response.data.result.errors[0].info;
                                  }
                                  window.scroll({
                                            top: 520,
                                            left: 0,
                                            behavior: 'smooth'
                                          });
                                  ventana.beforeSubmit = false;
                                }else{
                                  if(error.response.data.result.errors[0].errorCode == "ZZ42"){//se trata de un primer login
                                    ventana.mensajePrimerLogin=true; //hay que ponerlo asi porque no se pueden poner etiquetas html de vue (router link) de manera dinamica
                                  }else if(error.response.data.result.errors[0].errorCode == "62MR"){
                                    ventana.mensajeError= error.response.data.result.errors[0].errorCode +" - Usuario Bloqueado. Por favor, contacte con su oficina"
                                  }else if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve otro error en concreto
                                    //ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                                    ventana.mensajeError= error.response.data.result.errors[0].errorCode +" - Algo ha ido mal, asegúrate que has introducido correctamente tus datos"
                                  }else{ //si no, por defecto
                                    ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                                  }
                                  ventana.confirmacion='KO';
                                  window.scroll({
                                    top: 0,
                                    left: 0,
                                    behavior: 'smooth'
                                  });
                                }
                              }else{
                                if(error.response.status=='404'){ //error de conexion o ruta incorrecta
                                  ventana.mensajeError='No se ha podido establecer conexión con el servidor';
                                }else{
                                  if(error.response.data.result.errors[0].errorDescription!=null){ //si devuelve un error en concreto
                                    ventana.mensajeError=error.response.data.result.errors[0].errorDescription;
                                  }else{ //si no, por defecto
                                    ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente tus datos';
                                  }
                                }
                                ventana.confirmacion='KO';
                                ventana.$http.defaults.headers.common['Authorization'] = null;
                                window.scroll({
                                  top: 0,
                                  left: 0,
                                  behavior: 'smooth'
                                });
                              }
                      }
                    })
                    .then(function () {
                      loader.hide();
                    });
    },
    controlCaptcha() {
      if(this.captchaUrl){
        var key=this.captchaKey;
        var vueWindow=this;
              grecaptcha.ready(function() {
                    grecaptcha.execute(key, {action: 'submit'}).then(function(token) {
                    
                    vueWindow.grecaptchaResponse = token;
                    vueWindow.entrar();
                });
              });
      }else{
        this.entrar();
      }
      
    }
  }
}
</script>